import React from "react";

interface CDIsContainerProps {
  itemId?: string;
  children: React.ReactNode;
}

const CDIsContainer = ({itemId, children} : CDIsContainerProps) => {

  return (
    <div className={`CDIs-container ${itemId ? "CDIs-container-detail" : ""}`}>
      {children}
    </div>
  );
};

export default CDIsContainer;